import { render, staticRenderFns } from "./SoldSoferi.vue?vue&type=template&id=363897fe&scoped=true&"
import script from "./SoldSoferi.vue?vue&type=script&lang=js&"
export * from "./SoldSoferi.vue?vue&type=script&lang=js&"
import style0 from "./SoldSoferi.vue?vue&type=style&index=0&id=363897fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363897fe",
  null
  
)

export default component.exports